import { Box } from '@betterment/samba-react';
import { useNavigate } from 'react-router-dom';

import { SOCURE_CONTAINER_ID } from '../../DocumentVerification/constants';
import { WorkflowLayout } from '../../Shared/layout/WorkflowLayout';
import { urlBuilder } from '../../Shared/urlBuilder';

export const Upload = () => {
  const navigate = useNavigate();

  return (
    <WorkflowLayout
      pageTitle="Document Verification"
      onClose={() => navigate(urlBuilder.appHome.path)}
      workflowTitle="Identity Check"
      size="large"
    >
      <Box id={SOCURE_CONTAINER_ID} data-testid="socure-websdk" />
    </WorkflowLayout>
  );
};
